import React, { useState } from 'react';
import { API_URL, WHATSAPP_LINK } from '../config';
import { trackEvent } from '../analytics';

// הטופס שולח את הפרטים בוואטסאפ (חינם, בלי שרת) — נפתחת שיחה עם הודעה מוכנה
// שמכילה את כל פרטי הטופס, ונשאר רק ללחוץ "שלח".
// במקביל הפנייה נשמרת גם במערכת הניהול (אם השרת זמין).
function ContactForm({ isFullPage = false }) {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
    const [status, setStatus] = useState({ state: 'idle', message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const whatsappText = [
            'פנייה חדשה מהאתר:',
            `שם: ${formData.name}`,
            `טלפון: ${formData.phone}`,
            formData.email ? `אימייל: ${formData.email}` : null,
            `הודעה: ${formData.message}`,
        ].filter(Boolean).join('\n');

        // חייב להיפתח באופן מיידי בתוך אירוע הלחיצה, אחרת הדפדפן חוסם את החלון
        window.open(`${WHATSAPP_LINK}?text=${encodeURIComponent(whatsappText)}`, '_blank', 'noopener');

        trackEvent('contact_submit', { form: isFullPage ? 'contact_page' : 'footer' });

        // שמירה במערכת הניהול ברקע — לא חוסם את המשתמש גם אם השרת ישן
        fetch(`${API_URL}/api/contact`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        }).catch(() => {});

        setStatus({
            state: 'success',
            message: 'וואטסאפ נפתח עם הפרטים שלכם — נשאר רק ללחוץ על כפתור השליחה!',
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className={isFullPage ? "row gtr-uniform" : "fields"}>
                {isFullPage ? (
                    <>
                        <div className="col-6 col-12-xsmall"><input type="text" name="name" placeholder="שם מלא" value={formData.name} onChange={handleChange} required /></div>
                        <div className="col-6 col-12-xsmall"><input type="tel" name="phone" placeholder="טלפון" value={formData.phone} onChange={handleChange} required /></div>
                        <div className="col-12"><input type="email" name="email" placeholder="אימייל (לא חובה)" value={formData.email} onChange={handleChange} /></div>
                        <div className="col-12"><textarea name="message" placeholder="כתבו לנו על הפרויקט שלכם..." rows="5" value={formData.message} onChange={handleChange} required></textarea></div>
                    </>
                ) : (
                    <>
                        <div className="field half"><input type="text" name="name" placeholder="שם מלא" value={formData.name} onChange={handleChange} required /></div>
                        <div className="field half"><input type="tel" name="phone" placeholder="טלפון" value={formData.phone} onChange={handleChange} required /></div>
                        <div className="field"><input type="email" name="email" placeholder="אימייל (לא חובה)" value={formData.email} onChange={handleChange} /></div>
                        <div className="field"><textarea name="message" placeholder="הודעה" rows="4" value={formData.message} onChange={handleChange} required></textarea></div>
                    </>
                )}
            </div>
            <ul className="actions">
                <li>
                    <button type="submit" className="button whatsapp submit-whatsapp">
                        <i className="fab fa-whatsapp icon"></i> שליחה בוואטסאפ
                    </button>
                </li>
            </ul>
            {status.message && (
                <p className={`form-status form-status-${status.state}`} role="status">{status.message}</p>
            )}
        </form>
    );
}

export default ContactForm;
